import { HashRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import OrderForm from './pages/OrderForm';
import EmbedForm from './pages/EmbedForm';
import ThankYou from './pages/ThankYou';
import Layout from './components/Layout';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="form/:id" element={<OrderForm />} />
          <Route path="*" element={<ThankYou />} />
        </Route>
        <Route path="/embed/:id" element={<EmbedForm />} />
      </Routes>
    </HashRouter>
  );
}

export default App;